/** "Bugün gizle" tercihi yalnız bu tarayıcıda tutulur (spec 2026-09-24 §3.3). */
export const BANNER_DISMISS_PREFIX = 'kx.banner.dismissed.';

/** Kullanıcının YEREL takvim günü; gün dönümü kullanıcının gece yarısıdır, UTC değil. */
export function localDayKey(now: Date = new Date()): string {
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');

    return `${now.getFullYear()}-${m}-${d}`;
}

export function isDismissedToday(kind: string, now: Date = new Date()): boolean {
    try {
        return localStorage.getItem(BANNER_DISMISS_PREFIX + kind) === localDayKey(now);
    } catch {
        // Bilinçli fail-open (spec §7): depo erişilemezse bant gösterilir; kayıp yalnız bir kolaylık.
        return false;
    }
}

export function dismissToday(kind: string, now: Date = new Date()): void {
    try {
        localStorage.setItem(BANNER_DISMISS_PREFIX + kind, localDayKey(now));
    } catch {
        // Bilinçli fail-open (spec §7): yazılamazsa bant yalnız bu oturumda gizlenir (bileşen sinyali).
    }
}
